import {
    executetreatOrderItem,
    getTreatOrderAllList, getTreatOrderItemList, getPatientListByName, clinicSqbOrderPay
} from "@/api";
import {addDateRange, message} from "@/assets/utils/common";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            tableHeight: 500,
            treatOrderParams:{
                projectType: null, // 诊疗项目
                patientName: null, // 患者姓名
                diagnosis: null, // 诊断
                params: null
            },
            nameSelectConShow: false,
            patientRange: [],
            treatOrder: {
                dateTime: null, // 就诊时间
                avatarImg: null, // 医生头像
                dppId: null, // 医生建档的患者ID
                dppName: null, // 患者姓名
                dppSex: null, // 患者性别
                dppAge: null, // 患者年龄
                dppPhone: null, // 患者手机号
                dppIdentity: null, // 患者身份证
                dppAddress: null, // 患者身地址
                dppAllergyHistory: null, // 患者过敏史
                docId: null, // 医生ID
                diagnosis: null, // 诊断
                projectType: null, // 诊疗项目
                projectName: null, // 项目类型
                treatPrice: null, // 金额
                orderPrice: null, // 实收
                treatOrderItemList: [], // 检查治疗项目订单对应子项目记录信息
                remark: null, // 备注
            },

            treatLoading: false,
            treatOrderItem: {
                treatId: '',
            },
            treatItemData: [],
            treatmentItem: {
                itemType: null, // 项目类型
            },
            treatItemList: [],

            orderTableLoading: false,
            dateTime: null,
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            patientId: null,
            direction: 'rtl',

            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            printDate: null, // 打印日期
            treatOrderDetailVisible: false, // 检查治疗单详情弹窗
            payCodeList: [], // 预览的支付码
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部检查治疗单', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部检查治疗单', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            removeScanListener: null // 用于存储移除扫码监听器的函数
        }
    },
    mounted() {
        this.resizeTableHeight();
        this.initScanListener();
    },
    created() {
        this.getTreatHistoryOrderList();
    },
    // 在 beforeDestroy 钩子中清理事件监听器
    beforeDestroy() {
        // 如果存在移除监听器的函数，则调用它
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            console.log("this.treatOrderItem.treatId >>>>" + this.treatOrderItem.treatId);
            console.log("treatOrder orderPrice >>>>" + this.treatOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            this.payLoading = true;
            this.isPayed = false;
            let params = {
                orderId: this.treatOrderItem.treatId,
                price: this.treatOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
            console.log("this.payLoading >>>>" + this.payLoading);
            console.log("this.isPayed >>>>" + this.isPayed);
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                if (response.code === 200) {
                    message("支付成功", "success");
                    this.successPayed = true;
                } else {
                    this.successPayed = false;
                    message(response.msg || "支付失败", "error");
                }
                console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
                console.log("this.payLoading >>>>" + this.payLoading);
                console.log("this.isPayed >>>>" + this.isPayed);
            }).catch(error => {
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                this.payLoading = true;
            });
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.treatOrderParams.patientName = queryName;
                getPatientListByName(this.treatOrderParams).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    sex: item.sex === '0'?'男':item.sex === '1'?'女':'未知',
                                    age: item.age,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                        }
                    } else {
                        this.nameSelectConShow = false;
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.treatOrder.dppId = null;
                this.currentPage = 1;
                this.getTreatHistoryOrderList();
            }
        },


        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
        },


        // 取消支付
        cancalPay() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
        },



        // 确定选择患者
        sureChoosePatient(dppId, patientName) {
            this.treatOrder.dppId = dppId;
            this.treatOrderParams.patientName = patientName;
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },

        // 表格高度自适应
        resizeTableHeight() {
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
                        this.tableHeight = this.$refs.multipleOrderTable.clientHeight - 190;
                    })
                }
            }, 100)
        },

        // 选择时间
        chooseDateTime(){
            addDateRange(this.treatOrderParams, this.dateTime);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getTreatHistoryOrderList();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getTreatHistoryOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.treatOrderParams.diagnosis = null;
            this.treatOrderParams.projectType = null;
            this.treatOrder.dppId = null;
            this.dateTime = [];
            addDateRange(this.treatOrderParams, this.dateTime);
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },


        // 执行检查治疗项目
        executetreatOrderItemFunc(itemId, toId, projectName) {
            this.$confirm('确定要执行当前所选项目吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                //根据工单类型筛选，已完成订单
                executetreatOrderItem(toId).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        message("所选的 " + projectName + " 项目执行成功！", "success");
                        this.qryryTreatItemList(itemId);
                    } else {
                        message("所选的 " + projectName + " 项目执行失败！原因：" + response.msg, "error");
                    }
                });
            }).catch(() => {
                console.log('用户取消切换');
            })
        },

        // 已执行提示
        executedFunc(projectName) {
            message("所选的 " + projectName + " 项目暂无法执行或已经执行完成，请核对后重试！", "warning");
        },


        // 查询检查治疗项目工单
        getTreatHistoryOrderList() {
            this.tableLoading = true;
            //根据工单类型筛选，已完成订单
            this.treatOrderParams.dppId = this.treatOrder.dppId;
            this.treatOrderParams.docId = this.treatOrder.docId;
            this.treatOrderParams.pageNum = this.currentPage;
            this.treatOrderParams.pageSize = this.pageNums;
            getTreatOrderAllList(this.treatOrderParams).then(response => {
                console.log(response);
                this.tableLoading = false;
                if (response.data.code === 200) {
                    this.totalCount = response.data.total;
                    this.tableData = response.data.rows;
                    this.treatItemData = response.data.rows.treatOrderItemList;
                    if (this.tableData.length > 0) {
                        this.tableData.forEach(item=>{
                            item.isExpandRow = false;
                            item.isExecutedNum = 0;
                            if (item.treatOrderItemList.length > 0) {
                                item.treatOrderItemList.forEach(itm=>{
                                    if (itm.excuteStatus === '1') {
                                        item.isExecutedNum++;
                                    }
                                })
                            }
                            if (item.isExecutedNum === item.treatOrderItemList.length) {
                                item.isExecutedInfo = '2';
                                item.orderStatus = '3';
                            } else if (item.isExecutedNum === 0) {
                                item.isExecutedInfo = '0';
                            } else {
                                item.isExecutedInfo = '1';
                            }

                            if (item.dppSex === "1") {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else if (item.dppSex === "0") {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            });
        },


        // 打开详情展示弹窗
        expandRowDetail(items) {
            this.treatOrderDetailVisible = true;
            this.treatLoading = true;
            this.treatOrder = items;
            this.payCodeList = [];
            this.payCodeList.push(this.tencentCosUrl+items.payQrcode);
            this.treatOrderItem.treatId = items.id;
            getTreatOrderItemList(this.treatOrderItem).then(response => {
                console.log(response);
                this.treatLoading = false;
                this.treatItemData = [];
                if (response.data.code === 200) {
                    this.treatItemData = response.data.rows;
                }
            });
        },


        // 取消详情展示弹窗
        cancelTreatDetail() {
            this.treatOrderDetailVisible = false;
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
